/**
 * The club changed how it takes payment between the quote and the member's click — read
 * off the ENVELOPE (internalapi-envelope shape), like `getPromotionRejection`.
 *
 * The server refuses with `payment_timing_changed` when the member was quoted "pay at the
 * club" and the club now charges a card, or the reverse. Nothing was booked or charged; the
 * step's answer is to re-quote, so the checkout redraws the way the club now runs it, and
 * show the server's member copy.
 *
 * @module lib/apiClient/paymentTimingChanged
 */

import type { ApiErrorResult } from './types';

/** The member copy when the failure envelope is a timing change, otherwise null. */
export function getPaymentTimingChange(result: ApiErrorResult): string | null {
  return result.error?.code === 'payment_timing_changed' ? result.message : null;
}
